import van from "vanjs-core";
import { reactive } from "vanjs-ext";
import { router } from "..";
import { findUser } from "../api/users";
import {
	getUser,
	putUserEmail,
	putUserVerifyEmail,
} from "../api/users_{userId}";
import { config } from "../app-env/common";
import { state } from "../state";
import { centeredBox } from "../van/centered-box";
import {
	a,
	button,
	div,
	input,
	li,
	nav,
	pre,
	table,
	tbody,
	td,
	tr,
	ul,
} from "../van/van-tags";
import { errorToast, successToast } from "../view/components";

/**
 * @param {import("navigo").Match} ctx
 */
export async function adminFindUserPage(ctx) {
	const loading = van.state(false);
	const query = van.state("");
	/** @type {import("vanjs-core").State<User[]>} */
	const users = van.state([]);

	const onClickSearch = () => {
		loading.val = true;
		findUser("email", query.val)
			.then((result) => {
				if (result.length === 1)
					router.jump(`/admin/user/${result[0].Id}`);
				else users.val = result;
			})
			.catch(errorToast)
			.finally(() => {
				loading.val = false;
			});
	};

	return centeredBox(
		{
			size: "narrow",
		},
		nav(
			{
				class: "breadcrumb",
			},
			ul(
				li(
					a(
						{
							onclick: () => router.jump("/admin"),
						},
						"Admin",
					),
				),
				li(a("User")),
			),
		),
		div(
			{
				class: "field has-addons",
			},
			div(
				{
					class: "control is-expanded",
				},
				input({
					class: "input",
					oninput: (e) => {
						query.val = e.target.value;
					},
					placeholder: "Email",
				}),
			),
			div(
				{
					class: "control",
				},
				button(
					{
						class: () =>
							loading.val
								? "button is-primary is-loading"
								: "button is-primary",
						disabled: () => loading.val,
						onclick: onClickSearch,
					},
					"Search",
				),
			),
		),
		table(
			{
				class: "table is-fullwidth is-striped",
			},
			() =>
				tbody(
					users.val.map((user) =>
						tr(
							td(
								a(
									{
										onclick: () =>
											router.jump(
												`/admin/user/${user.Id}`,
											),
									},
									user.Email,
								),
							),
						),
					),
				),
		),
	);
}

/**
 * @param {import("navigo").Match} ctx
 */
export async function adminInspectUserPage(ctx) {
	if (!ctx || !ctx.data || !ctx.data.id) throw "missing ctx.data.id";

	const page = reactive({
		email: "",
		loading: false,
		user: await getUser(ctx.data.id),
	});

	function onClickImpersonate() {
		page.loading = true;
		state
			.startImpersonating(page.user)
			.then(() => router.jump("/devices"))
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	}

	function onClickSaveEmail() {
		page.loading = true;
		putUserEmail(page.user.Id, page.email)
			.then((user) => {
				page.user = user;
				successToast();
			})
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	}

	function onClickVerifyUser() {
		page.loading = true;
		putUserVerifyEmail(page.user.Id)
			.then((user) => {
				page.user = user;
				successToast();
			})
			.catch(errorToast)
			.finally(() => {
				page.loading = false;
			});
	}

	return centeredBox(
		{
			size: "narrow",
		},
		nav(
			{
				class: "breadcrumb",
			},
			ul(
				li(
					a(
						{
							onclick: () => router.jump("/admin"),
						},
						"Admin",
					),
				),
				li(
					a(
						{
							onclick: () => router.jump("/admin/user"),
						},
						"User",
					),
				),
				li(a(page.user.Email)),
			),
		),
		div(
			{
				class: "buttons",
			},
			button(
				{
					class: () =>
						page.loading
							? "button is-primary is-loading"
							: "button is-primary",
					disabled: () => page.loading,
					onclick: onClickImpersonate,
				},
				"Impersonate",
			),
			button(
				{
					class: () =>
						page.loading
							? "button is-primary is-loading"
							: "button is-primary",
					disabled: () => page.loading,
					onclick: () =>
						window.open(
							`${config.stripeBaseUrl}/customers/${page.user.CustomerId}`,
							"_blank",
						),
				},
				"Stripe",
			),
			button(
				{
					class: () =>
						page.loading
							? "button is-primary is-loading"
							: "button is-primary",
					disabled: () => page.loading,
					onclick: onClickVerifyUser,
				},
				"Verify",
			),
		),
		div(
			{
				class: "field has-addons",
			},
			div(
				{
					class: "control",
				},
				input({
					class: "input",
					oninput: (e) => {
						page.email = e.target.value;
					},
					placeholder: "new email",
					value: () => page.email,
				}),
			),
			div(
				{
					class: "control",
				},
				button(
					{
						class: () =>
							page.loading
								? "button is-primary is-loading"
								: "button is-primary",
						disabled: () => page.loading,
						onclick: onClickSaveEmail,
					},
					"Save",
				),
			),
		),
		pre({ class: "is-tiny-mobile" }, () =>
			JSON.stringify(page.user, null, 2),
		),
	);
}
